import { orange, purple } from '@material-ui/core/colors';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

const theme = createMuiTheme({
  palette: {
    primary: purple,
    secondary: orange,
  },
  typography: {
    useNextVariants: true,
    fontSize: 12,
  },
});

const ABGProjectLanding = () => {
  const { record_id } = useParams();
  const [pdfUri, setPdfUri] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPdfUrl = async () => {
      try {
        const response = await window.sch.get(
          `/api/abg_project/get_url/${record_id}`
        );
        setPdfUri(response.url);
        setError(null);
      } catch (err) {
        setError(err);
        setPdfUri(null);
      }
    };

    fetchPdfUrl();
  }, [record_id]);

  return (
    <>
      <CssBaseline />
      <MuiThemeProvider theme={theme}>
        <main>
          <div>
            {error && <div>Error: {error.message}</div>}
            {pdfUri && (
              <embed
                type="application/pdf"
                src={pdfUri + '#zoom=75'}
                style={{ width: '99%', height: 1200 }}
              />
            )}
          </div>
        </main>
      </MuiThemeProvider>
    </>
  );
};

ABGProjectLanding.propTypes = {};

const mapStateToProps = (stateFromStore) => ({
  me: stateFromStore.me,
  lookups: stateFromStore.lookups,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ABGProjectLanding)
);
